import React from 'react';
import {WithTranslationProps} from 'react-i18next';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';

interface ActivatedOnProps extends WithTranslationProps {
  item: {
    activatedOn: string;
  };
}

export const ActivatedOn: React.FC<ActivatedOnProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = {},
}) => {
  const activatedOn = get(item, 'activatedOn', {});
  return tt(
    'activatedOn',
    generateComponentCallback({
      component: (
        <Text
          testID={Reports.reportActivatedOn}
          allowFontScaling
          maxFontSizeMultiplier={2}>
          Joined{' '}
          {getDateUtilDefaultInstance().formatDate(activatedOn, 'MMMM d, yyyy')}
        </Text>
      ),
    }),
  );
};

export default withTranslation('report.record.activatedOn')(ActivatedOn);
